import {BulkEditFieldNameEnum} from '../../../../../../service/company/company-type';
import {GalleryFormItem as CompanyGalleryFormItem} from '../../../../company-form/page-container/widgets/gallery/gallery-form-item/gallery-form-item';
import {BaseCompanyFormItemPropsType} from '../company-form-items-type';

type PropsType = BaseCompanyFormItemPropsType<BulkEditFieldNameEnum.gallery>;

function collectMessages(value: unknown): Array<string> {
    if (typeof value === 'string') {
        return [value];
    }

    if (Array.isArray(value)) {
        return value.flatMap(collectMessages);
    }

    if (value && typeof value === 'object') {
        return Object.values(value).flatMap(collectMessages);
    }

    return [];
}

/**
 * extractFieldServerError hands back whatever the API put in `value`, and that is not always the array the
 * type promises: a per-file rejection arrives keyed by index ({"gallery": {"value": {"0": ["…"]}}}) and
 * a video one as objects ({"company_videos": {"value": [{"temp_id": ["…"]}]}}). Calling .flat() on such
 * values used to throw inside the render and take the whole page down, so every nesting is walked here.
 */
function toFlatErrorMessage(errorMessage: PropsType['errorMessage']): Array<string> | null {
    const messages = collectMessages(errorMessage);

    return messages.length > 0 ? messages : null;
}

/** Bulk editing reuses the company form gallery block as is. */
export function GalleryFormItem(props: PropsType): JSX.Element {
    const {value, onChange, errorMessage} = props;
    const flatErrorMessage = toFlatErrorMessage(errorMessage);

    return (
        <CompanyGalleryFormItem
            errorMessage={flatErrorMessage ?? undefined} // eslint-disable-line no-undefined
            onChange={onChange}
            value={value}
        />
    );
}
